<script>
import baseList from "@/views/components/base/baseList.vue";
// import Track from './track.vue'
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "accountingDetail",
        key: "id",
        url: {
          list: "admin/system/check/getCheckDeskReportDetail",
        },
      },
      query: {},
      actions: [
        // {
        //   label: "新增",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   type: "info",
        //   auth: "system/inspection/add",
        // },
      ],
      menus: [],
      filters: [
        // {
        //   label: "使用科室",
        //   KeyEnter: this.search,
        //   name: "deskName",
        //   value: "",
        //   type: "input",
        // },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "核算科室",
          key: "checkDeskName",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.checkDeskName;
            return <span>{text}</span>;
          },
        },
        {
          title: "使用科室",
          key: "deskName",
          minWidth: 140,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.deskName;
            return <span>{text}</span>;
          },
        },
        {
          title: "型号",
          key: "facilityModel",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityModel;
            return <span>{text}</span>;
          },
        },
        {
          title: "设备类型",
          key: "typeName",
          width: 160,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.typeName;
            return <span>{text}</span>;
          },
        },
        {
          title: "安装日期",
          key: "installationTime",
          width: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.installationTime;
            return <span>{text}</span>;
          },
        },
        {
          title: "设备归属",
          key: "assetOwnership",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.assetOwnership;
            return <span>{text}</span>;
          },
        },
        {
          title: "单价",
          key: "monthMoney",
          width: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.monthMoney;
            return <span>{text}元</span>;
          },
        },
        {
          title: "折扣率",
          key: "discountRate",
          width: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.discountRate;
            return <span>{text}%</span>;
          },
        },
        {
          title: "价格",
          key: "serviceMoney",
          width: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.serviceMoney;
            return <span>{text}元</span>;
          },
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    this.query = query;
    console.log(this.query);
  },
  methods: {},
};
</script>
<style scoped></style>
